/* Product-card titles: at most two lines, then "..." (Eli, 2026-10-13).
 * CSS -webkit-line-clamp does the clamp without JavaScript, but browsers centre the cut line
 * before they draw the ellipsis, so on centred cards that line sits about half an ellipsis to the
 * right. This cuts the title at a whole word, adds the ellipsis as real text and lets the browser
 * centre that. The full title stays in data-full-title and in the title tooltip; a title that is a
 * link also keeps it as its accessible name. Cards added later (sold gallery, wishlist, search)
 * are fitted as they arrive, and every title is refitted when the width or the fonts change.
 */
(function () {
  'use strict';
  var SELECTOR = '.pcard-name:not(.pcard-rel-name), .pcard-title, .wl-name';
  var LINES = 2;

  function fit(el) {
    var full = el.getAttribute('data-full-title');
    if (full === null) {
      full = el.textContent.replace(/\s+/g, ' ').trim();
      el.setAttribute('data-full-title', full);
    }
    el.classList.remove('is-fit');
    if (el.textContent !== full) el.textContent = full;
    // Under the CSS clamp the box shows two lines; anything taller was cut.
    if (el.scrollHeight <= el.clientHeight + 1) return;

    el.classList.add('is-fit');
    var lineHeight = parseFloat(getComputedStyle(el).lineHeight) || 20;
    var limit = lineHeight * LINES + 1;
    var words = full.split(' ');
    var low = 1, high = words.length - 1, best = 1;
    while (low <= high) {
      var mid = (low + high) >> 1;
      el.textContent = words.slice(0, mid).join(' ').replace(/[\s,&;:\-]+$/, '') + '…';
      if (el.getBoundingClientRect().height <= limit) { best = mid; low = mid + 1; } else { high = mid - 1; }
    }
    el.textContent = words.slice(0, best).join(' ').replace(/[\s,&;:\-]+$/, '') + '…';
    el.title = full;
    if (el.tagName === 'A') el.setAttribute('aria-label', full);
  }

  function fitWithin(root) {
    if (root.nodeType !== 1) return;
    if (root.matches(SELECTOR)) fit(root);
    var found = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < found.length; i++) fit(found[i]);
  }

  function fitAll() { fitWithin(document.body); }

  fitAll();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);

  var width = window.innerWidth, pending = 0;
  window.addEventListener('resize', function () {
    if (window.innerWidth === width) return;
    width = window.innerWidth;
    cancelAnimationFrame(pending);
    pending = requestAnimationFrame(fitAll);
  });

  new MutationObserver(function (records) {
    for (var r = 0; r < records.length; r++) {
      var added = records[r].addedNodes;
      for (var n = 0; n < added.length; n++) fitWithin(added[n]);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
